import { Fragment } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import NotificationItem from '../../components/NotificationItem';
import { SupplierStatuses } from 'src/modules/3rd-party-management/constants';
import DateUtils from 'src/services/utils/DateUtils';
import {
    INTERNATIONAL_DATE_FORMAT
} from 'src/common/constants';
import { roles } from 'src/pages/Admin/administration/user-management/data';

const Handler = ({
    notifications,
    t
}) => {
    const dateUtils = new DateUtils();

    const handleTranslateOnType = (notification) => {
		const notificationType = notification.message_type;

		switch (notificationType) {
            /**
             * admins
             */
            case 'third_party_manager_updated': {
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;
              
                return (
                  <Fragment>
                    <span className="d-block">
                      {t('New manager(s) added to supplier information')}.
                    </span>
                    <span className="d-block">
                      {t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
                    </span>
                  </Fragment>
                );
              }
              
              case 'third_party_shareholder_updated': {
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;
              
                return (
                  <Fragment>
                    <span className="d-block">
                      {t('New shareholder(s) added to supplier information')}.
                    </span>
                    <span className="d-block">
                      {t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
                    </span>
                  </Fragment>
                );
              }
              
              case 'third_party_location_updated': {
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;
              
                return (
                  <Fragment>
                    <span className="d-block">
                      {t('New location(s) added to supplier information')}.
                    </span>
                    <span className="d-block">
                      {t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
                    </span>
                  </Fragment>
                );
              }
            
            case 'admin_report_submitted': {
                return (
					<Fragment>
						<span className='d-block'>{t('Your report has been submitted')}.</span>
					</Fragment>
				);
            }
            case 'report_request_expiration_over': {
                const {
                    supplierSecondaryId,
                    isOwnCompany,
                    name
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>
                            {t('The report request deadline has expired')}.
                        </span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
				);
			}
            case 'report_request_assigned':{
                const { 
                    supplierSecondaryId, 
                    isOwnCompany,
                    name
                } = notification.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t('You have a new report request')}.
                        </span>
                        <span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
                    </Fragment>
                );
            }
            case 'supplier_replace_contact_person': {
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t('A third party has introduced another contact person')}.
                        </span>
                        <span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
                    </Fragment>
                );
            }
            case 'supplier_assigned':{
                const { name, supplierSecondaryId } = notification.data;

                return (
                    <>
                        <span className='d-block'>
                            {t('You have been assigned to a third party')}.
                        </span>
                        <span className='d-block'>
                            {t('Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
                        </span>
                    </>
                );
            }
            case 'owncompany_assigned':{
                const { name, supplierSecondaryId } = notification.data;

                return (
                    <>
                        <span className='d-block'>
                            {t('You have been assigned to an own entity')}.
                        </span>
                        <span className='d-block'>
                            {t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
                        </span>
                    </>
                );
            }
            case 'new_case_reported': {
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('You have received a new report')}.</span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
				);
			}
            case 'new_comment': {
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;

                return (
					<Fragment>
						<span className='d-block'>
							{t(isOwnCompany ? 'New comment from company' : 'New comment from third party')}.
						</span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
				);
			}
            case 'new_internal_comment':
            case 'new_internal_comment_to_assigned_analyst': {
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>
                            {t('You have received a new internal comment')}.
                        </span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
				);
			}
            case 'new_external_comment_to_assignedanalyst':{
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>
                            {t('You have received a new comment')}.
                        </span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
				);
            }
            case 'new_external_comment_from_tp_assignedanalyst':{
                const { supplierSecondaryId, isOwnCompany, name } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>
                            {t('You have received a new comment')}.
                        </span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
				);
            }
            case 'change_supplier_status':{
                const { 
                    supplierSecondaryId,
                    isOwnCompany,
                    name,
                    new_status
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>
                            {
                                isOwnCompany ? 
                                    t(`Company status changed to ${SupplierStatuses[new_status]?.title}`) : 
                                    t(`Third party status changed to ${SupplierStatuses[new_status]?.title}`)
                            }.
                        </span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
				);
            }
            case 'in_active_user': {
                const { name, role} = notification?.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A user was deactivated.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'active_user': {
                const { name, role} = notification?.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A user was activated.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'add_user': {
                const { name, role} = notification?.data;
                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A new user was added to your SIP.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'delete_user': {
                const { name, role} = notification?.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A user was deleted.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'sucessor_admin_to_risks_tasks_reports': {
                const { priorUser } = notification?.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("All open risks, tasks, third parties, and report requests have been reassigned.")}
                        </span>
                        <span className='d-block'>
                            {`${t("From")}: ${priorUser}`}
                        </span>
                    </Fragment>
                )
            }
            case 'user_limitation_over': {
                return <span>{t("You have reached your max license limit. Please reach out to the SIP support.")}</span>
            }

            case 'supplier_limitation_over': {
                return <span>{t("You have reached your max third-party limitation. Please reach out to the SIP support for an upgrade.")}</span>
            }

            case 'own_company_limitation_over': {
                return <span>{t("You have reached your max own company limitation. Please reach out to the SIP support for an upgrade.")}</span>
            }
            /**
             * admins
             * risks
             */
            case 'risk_assign': {
                const { 
                    secondaryRiskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('A new risk has been assigned to you.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryRiskId}
						</span>
					</Fragment>
				);
			}
            case 'risk_comment': {
                const { 
                    secondaryRiskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('A comment was added to your risk.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryRiskId}
						</span>
					</Fragment>
				);
			}
            case 'risk_change_description': {
                const { 
                    secondaryRiskId
                } = notification.data;
                return (
					<Fragment>
						<span className='d-block'>{t('Description of your risk was changed')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryRiskId}
						</span>
					</Fragment>
				);
			}
            case 'risk_rating': {
                const { 
                    riskRate	
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The rating of your risk has been changed.')}</span>
						<span className='d-block'>
							{t('New rating')}: {t(riskRate)}
						</span>
					</Fragment>
				);
			}
            /**
             * admins
             * tasks
             */
            case 'upcoming_recurring_task': {
                const { 
                    secondaryTaskId
                } = notification.data;
				return (
					<Fragment>
                        <span className='d-block'>
                            <i
                                className="ri-repeat-2-line text-info me-1 font-size-16 align-middle"
                            />
                            {t('You have a recurring task approaching its due time. Please review it in your tasks.')}
                        </span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
					</Fragment>
				);
            }
            case 'new_task_created': {
                const { 
                    secondaryTaskId,
                    isRecurring
                } = notification.data;
				return (
					<Fragment>
                        {isRecurring ? (
                            <span className='d-block'>
                                <i
                                    className="ri-repeat-2-line text-info me-1 font-size-16 align-middle"
                                />
                                {t('A new recurring task has been assigned to you.')}
                            </span>
                        ) : (
                            <span className='d-block'>
                                {t('A new task has been assigned to you.')}
                            </span>
                        )}
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
					</Fragment>
				);
			}
			case 'task_status_new': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The status of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New status')}: {t('New')}
						</span>
					</Fragment>
				);
			}
			case 'task_status_in_progress': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The status of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New status')}: {t('In Progress')}
						</span>
					</Fragment>
				);
			}
			case 'task_status_review': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The status of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New status')}: {t('Review')}
						</span>
					</Fragment>
				);
			}
			case 'task_status_delete': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The status of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New status')}: {t('Deleted')}
						</span>
					</Fragment>
				);
			}
			case 'task_status_close': {
                const {
                    secondaryTaskId
                } = notification.data;
                
				return (
					<Fragment>
						<span className='d-block'>{t('The status of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New status')}: {t('Closed')}
						</span>
					</Fragment>
				);
			}
			case 'task_priority_low': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The priority of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New priority')}: {t('Low')}
						</span>
					</Fragment>
				);
			}
			case 'task_priority_medium': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The priority of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New priority')}: {t('Medium')}
						</span>
					</Fragment>
				);
            }
			case 'task_priority_high': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The priority of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
						<span className='d-block'>
							{t('New priority')}: {t('High')}
						</span>
					</Fragment>
				);
            }
			case 'task_comment':{
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('A comment was added to your task')}.</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
					</Fragment>
				);
            }
			case 'task_before_overdue': {
                const {
                    taskId,
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The deadline for the task is soon.')}</span>
						<span className='d-block'>
							{secondaryTaskId
								? '\n' + t('Task ID') + ': ' + secondaryTaskId
								: taskId
								? '\n' + t('Task ID') + ': ' + taskId
								: ''}
						</span>
					</Fragment>
				);
			}
			case 'new_task': {
				return <span className='d-block'>{t('You created a new task')}.</span>;
			}
			case 'task_change_deadline': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('Deadline of your task was changed')}.</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
					</Fragment>
				);
			}
			case 'task_change_description': {
                const {
                    secondaryTaskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The description of your task has been changed.')}</span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
					</Fragment>
				);
			}
			case 'task_overdue': {
                const {
                    secondaryTaskId,
                    taskId
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>{t('The deadline for your task is today.')}</span>
						<span className='d-block'>
							{secondaryTaskId
								? '\n' + t('Task ID') + ': ' + secondaryTaskId
								: taskId
								? '\n' + t('Task ID') + ': ' + taskId
								: ''}
						</span>
					</Fragment>
				);
			}
            case 'received_news': {
                const { 
                    supplierSecondaryId,
                    isOwnCompany,
                    name,
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {t('New news has been added for')}{` ${name}`}.
                        </span>
						<span className='d-block'>
							{t(isOwnCompany ? 'Company' : 'Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'new_bafa_news_own_company_assigned_analyst': {
                const { 
                    supplierSecondaryId,
                    name,
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {t('Please check the latest news')}.
                        </span>
						<span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'new_bafa_news_third_party_assigned_analyst': {
                const { 
                    supplierSecondaryId,
                    name,
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {t('Please check the latest news')}.
                        </span>
						<span className='d-block'>
							{t('Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case "new_risk_rating": {
                const {newRating, name} = notification?.data;
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("Your entity has a new risk rating.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("Name")}: {name}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New rating")}: {newRating}
                        </span>
                    </Fragment>
                );
            }
            case 'risk_setting_update': {
                return (
                    <Fragment>
						<span className='d-block'>
                            {t('Changes have been made to the risk settings.')}
                        </span>
					</Fragment>
                )
            }
            case 'sanction_limitation_over': {
                return (
                    <Fragment>
                        <span className='d-block'>
                            {t('You have reached your max third party sanctions screening limitation. Please reach out to the SIP support for an upgrade.')}
                        </span>
                    </Fragment>
                )
            }
            case 'rreq_ocom_exp_reminder_1_day': {
                const { 
                    deadline,
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Do not miss the deadline for the report!')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>

                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'rreq_ocom_exp_reminder_3_days': {
                const { 
                    deadline
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Do not miss the deadline for the report!')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'rreq_ocom_exp_reminder_1_week': {
                const { 
                    deadline
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have not submitted the report. The deadline is in one week.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'rreq_ocom_exp_reminder_2_week': {
                const { 
                    deadline,
                    supplierSecondaryId,
                    name
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Do not miss the deadline for the report!')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>

                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'r_overdue_ocom_rperson_1_day': {
                const { 
                    deadline,
                    name,
                    supplierSecondaryId
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Your report is overdue.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'r_overdue_ocom_rperson_2_weeks': {
                const { 
                    deadline,
                    name,
                    supplierSecondaryId
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Your report is overdue.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }

            case 'third_party_is_risky': {
                return (
                    <Fragment>
                        <span className='d-block'>
                            {`${t('Your TP is risky. Please filter by risk.')}`}
                        </span>
                    </Fragment>
                )
            }

            case 'own_company_is_risky': {
                return (
                    <Fragment>
                        <span className='d-block'>
                            {`${t('Your own company is risky. Please filter by risk.')}`}
                        </span>
                    </Fragment>
                )
            }

            case 'new_findings_for_thirdparty': {
                const { name } = notification?.data;
                return (
                    <Fragment>
                        <span className='d-block'>
                            {`${t('Your TP has new findings')}`}
                        </span>
                        <span className='d-block'>
                        {`${t('TP name')}: ${name}`}
                        </span>
                    </Fragment>
                )
            }

            case 'new_findings_for_owncompany': {
                const { name } = notification?.data;
                return (
                    <Fragment>
                        <span className='d-block'>
                            {`${t('Your own company has new findings')}`}
                        </span>
                        <span className='d-block'>
                        {`${t('Own company name')}: ${name}`}
                        </span>
                    </Fragment>
                )
            }
            case 'r_overdue_supp_aanalyst_1_day': {
                const { 
                    deadline,
                    supplierSecondaryId,
                    name
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('The third party report request is overdue since')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>

                        <span className='d-block'>
							{t('Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'r_overdue_ocom_aanalyst_1_day': {
                const { 
                    name,
                    deadline,
                    supplierSecondaryId
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('The entity report request is overdue since')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'r_overdue_supp_aanalyst_2_weeks': {
                const { 
                    deadline,
                    supplierSecondaryId,
                    name
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('The third party report request is overdue since')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>

                        <span className='d-block'>
							{t('Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'r_overdue_ocom_aanalyst_2_weeks': {
                const { 
                    name,
                    deadline,
                    supplierSecondaryId
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('The entity report request is overdue since')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'rc_submitted_ocom_rperson': {
                const { 
                    secondaryId,
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Thank you! Your report has been submitted.')}`}
                        </span>
                        
                        <span className='d-block'>
							{t('ID')}: {secondaryId}
						</span>
					</Fragment>
                )
            }
            case 'report_request_assigned_analyst': {
                const { 
                    responsible_person
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have requested a new report from')} ${responsible_person}`}
                        </span>
					</Fragment>
                )
            }

            case 'report_request_contact_person': {
                return (
                    <Fragment>
                        <span className='d-block'>
                            {t('A report request has been sent to you')}.
                        </span>
                    </Fragment>
                )
            }
            case 'comment_mention':{
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have been mentioned in a comment')}`}
                        </span>
					</Fragment>
                )
            }
            case 'rc_submitted_ocom_aanalyst':{
                const { 
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('An own entity has submitted a report')}`}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'rc_submitted_supp_aanalyst':{
                const { 
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('A third party has submitted a report')}`}
                        </span>
                        <span className='d-block'>
							{t('Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'rperson_assigend_to_ocom':{
                const { 
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have been assigned as the responsible person for the entity')}`}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'ten_year_old_report_case_owncompany':{
                const { 
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('The one company report is 10 years old. Please delete it if you do not need to keep it on record.')}`}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'ten_year_old_report_case_thirdparty':{
                const { 
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('The third party report is 10 years old. Please delete it if you do not need to keep it on record.')}`}
                        </span>
                        <span className='d-block'>
							{t('Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'new_third_party_created':{
                const { 
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('A new third party has been added to the SIP.')} ${t('Name')}: ${name}`}
                        </span>
					</Fragment>
                )
            }
            case 'new_own_company_created':{
                const { 
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('A new own company has been added to the SIP.')} ${t('Name')}: ${name}`}
                        </span>
					</Fragment>
                )
            }
            case 'new_legal_entity_is_added_manually':{
                const { 
                    entity_title
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('A new entity has been added to the SIP.')} ${t('Name')}: ${entity_title}`}
                        </span>
					</Fragment>
                )
            }
            case 'news_limitation_over':{
                return (
                    <span className='d-block'>
                        {t('The news license count is over.')}
                    </span>
                )
            }

            case 'new_legal_entity_list_uploaded': {
                return (
                    <span className='d-block'>
                        {t('Congrats! You have uploaded a new entity list.')}
                    </span>
                )
            }
            case 'new_screening_result_news_own_company_assigned_analyst':{
                const { 
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {t('New screening results are available for a monitored individual.')}
                        </span>
                        <span className='d-block'>
							{t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }
            case 'new_screening_result_news_third_party_assigned_analyst':{
                const { 
                    supplierSecondaryId,
                    name
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {t('New screening results are available for a monitored individual.')}
                        </span>
                        <span className='d-block'>
							{t('Third Party')}: {supplierSecondaryId}{name ? `/${name}` : ''}
						</span>
					</Fragment>
                )
            }

            /**
             * common
             */
            case 'withdraw_request': {
                const {
                    supplierSecondaryId,
                    isOwnCompany,
                    name
                } = notification.data;

				return (
					<Fragment>
						<span className='d-block'>
                            {t('Your report request has been withdrawn.')}
                        </span>
                        {isOwnCompany && (
                            <span className='d-block'>
                                {t('Company')}: {supplierSecondaryId}{name ? `/${name}` : ''}
                            </span>
                        )}
					</Fragment>
				);
			}

            /**
             * third parties
             */
            case 'rc_submitted_supp_cperson': {
				return (
					<Fragment>
						<span className='d-block'>
                            {t('Thank you! Your report has been submitted.')}
                        </span>
					</Fragment>
				);
			}
            case 'new_supplier_comment':
            case 'new_internal_comment_to_thirdparties': {
                return (
					<Fragment>
						<span className='d-block'>
                            {t('You have received a new comment')}.
                        </span>
					</Fragment>
				);
            }
            case 'rreq_supp_exp_reminder_1_day': {
                const { 
                    deadline
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have not submitted the report. The deadline is in one day.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'rreq_supp_exp_reminder_3_days': {
                const { 
                    deadline
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have not submitted the report. The deadline is in three days.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'rreq_supp_exp_reminder_1_week': {
                const { 
                    deadline
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have not submitted the report. The deadline is in one week.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'rreq_supp_exp_reminder_2_week': {
                const { 
                    deadline
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('You have not submitted the report. The deadline is in two weeks.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'r_overdue_supp_cperson_1_day': {
                const { 
                    deadline
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Your report is overdue.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'r_overdue_supp_cperson_2_weeks': {
                const { 
                    deadline
                } = notification.data;
                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('Your report is overdue.')} ${t('Deadline')}: ${dateUtils.convertTimeStampToDate(deadline, INTERNATIONAL_DATE_FORMAT)}`}
                        </span>
					</Fragment>
                )
            }
            case 'new_external_comment_to_thirdparties': {
                return (
                    <Fragment>
						<span className='d-block'>
                            {t('You have received a new comment')}.
                        </span>
					</Fragment>
                )
            }

			default: {
				return t(notificationType);
			}
		}
	}

    const handleRenderNotification = (notification, index) => {
		let link = '#';

		if (typeof notification.id !== 'undefined') {
			switch (notification.message_type) {
                /**
                 * admins
                 */
                case 'third_party_manager_updated':
                case 'third_party_shareholder_updated':
                case 'third_party_location_updated':
                    link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=basic-information`;
                    break;

                case 'admin_report_submitted':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=reports`
                    break;
                case 'report_request_expiration_over':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=basic-information`
                    break;
                case 'report_request_assigned':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=reports`
                    break;
                case 'supplier_replace_contact_person':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=basic-information`
                    break;
                case 'supplier_assigned':
                case 'owncompany_assigned':
                case 'new_third_party_created':
                case 'new_own_company_created':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=overview`
                    break;
                case 'new_comment':
                case 'new_external_comment_to_assignedanalyst':
                case 'new_external_comment_from_tp_assignedanalyst':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=communication`
                    break;
                case 'new_case_reported':
                case 'rc_submitted_ocom_aanalyst':
                case 'rc_submitted_supp_aanalyst':
                case 'rperson_assigend_to_ocom':
                case 'ten_year_old_report_case_owncompany':
                case 'ten_year_old_report_case_thirdparty':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=reports`
                    break;
                case 'new_internal_comment':
                case 'new_internal_comment_to_assigned_analyst':
                case 'comment_mention':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=internal-communication`
                    break;
                case 'change_supplier_status':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=overview`
                    break;
                case "third_party_is_risky":
                case "own_company_is_risky":
                        link = `3rd-party/manager?tab=suppliers`
                    break;
                case 'new_risk_rating':
                    link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=risk-assessment`
                    break;
                case 'in_active_user': 
                case 'active_user':
                case 'add_user': 
                        link = `3rd-party/administration/users/${notification.data.id}/edit`
                    break;
                case 'delete_user':
                case 'sucessor_admin_to_risks_tasks_reports':
                case 'user_limitation_over':
                    link = `3rd-party/administration/users`;
                    break;
                case 'supplier_limitation_over':
                    link = `3rd-party/manager?tab=suppliers`;
                    break;
                case 'own_company_limitation_over':
                    link = `3rd-party/manager/own`;
                    break;
                /**
                 *  admins
                 * risks 
                 **/    
                case 'risk_assign':
                case 'risk_comment':
                case 'risk_change_description':
                case 'risk_rating':
                        link = `3rd-party/suppliers/${notification.data.supplier}/risks/${notification.data.riskId}/details`
                    break;

                /**
                 * admins 
                 * tasks
                 */
                
                case 'new_task_created':
                case 'task_status_new':
                case 'task_status_in_progress':
                case 'task_status_review':
                case 'task_status_delete':
                case 'task_status_close':
                case 'task_priority_low':
                case 'task_priority_medium':
                case 'task_priority_high':
                case 'task_comment':
                case 'task_before_overdue':
                case 'new_task':
                case 'task_change_deadline':
                case 'task_change_description':
                case 'task_overdue':
                case 'upcoming_recurring_task':
                        link = `3rd-party/suppliers/${notification.data.supplier}/tasks/${notification.data.taskId}/details`
                    break;

                case 'rreq_ocom_exp_reminder_1_day':
                case 'rreq_ocom_exp_reminder_3_days':
                case 'rreq_ocom_exp_reminder_1_week':
                case 'rreq_ocom_exp_reminder_2_week':
                case 'r_overdue_ocom_rperson_1_day':
                case 'r_overdue_ocom_rperson_2_weeks':
                case 'r_overdue_supp_aanalyst_1_day':
                case 'r_overdue_ocom_aanalyst_1_day':
                case 'r_overdue_supp_aanalyst_2_weeks':
                case 'r_overdue_ocom_aanalyst_2_weeks':
                case 'rc_submitted_ocom_rperson':
                case 'report_request_assigned_analyst':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=reports`;
                    break;

                case 'new_legal_entity_is_added_manually':
                        link = `entity-management/entities/${notification.data.entity_id}/detail`;
                    break;

                case 'new_legal_entity_list_uploaded':
                        link = 'entity-management/entities';
                    break;
                    
                case 'received_news':
                case 'new_findings_for_thirdparty':
                case 'new_findings_for_owncompany':
                case 'new_bafa_news_own_company_assigned_analyst':
                case 'new_bafa_news_third_party_assigned_analyst':
                case 'new_screening_result_news_own_company_assigned_analyst':
                case 'new_screening_result_news_third_party_assigned_analyst':
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=findings`
                    break;
            
                case 'risk_setting_update':
                        link = `3rd-party/administration/settings?tab=risk-customization`
                    break;

                /**
                 * common
                 */

                case 'withdraw_request':{
                    const {
                        isOwnCompany
                    } = notification.data;

                    if(isOwnCompany){
                        link = `3rd-party/suppliers/${notification.data.supplier}/details?tab=reports`;
                    }
                    else{
                        link = "3rd-party/reports";
                    }
                    break;
                }
                
                /**
                 * third parties
                 */
                case 'new_external_comment_to_thirdparties':
                case 'new_supplier_comment':
                case 'new_internal_comment_to_thirdparties':
                        link = "3rd-party/communication"
                    break;
                case 'report_request_contact_person':
                case 'rc_submitted_supp_cperson':
                        link = "3rd-party/reports"
                    break;
                
                case 'rreq_supp_exp_reminder_1_day':
                case 'rreq_supp_exp_reminder_3_days':
                case 'rreq_supp_exp_reminder_1_week':
                case 'rreq_supp_exp_reminder_2_week':
                case 'r_overdue_supp_cperson_1_day':
                case 'r_overdue_supp_cperson_2_weeks':
                        link = "3rd-party/questioner"
                    break;

				default: break;
			}
		}

        return (
            <NotificationItem 
                index={index}
                link={link} 
                notification={notification}
                content={handleTranslateOnType(notification)}
            />
        )
	};

    return (
        <>
            {(notifications?.list || []).map((notification, index) => {
                return (
                    <div key={notification.id}
                        style={{
                            animationName: notification.hasMotion ? 'newNotificationAnimation' : '',
                            animationDuration: '0.6s',
                            animationIterationCount: 1,
                            overflow: 'hidden',
                            transition: 'opacity 0.3s ease 0s, max-height 0.3s ease 0.3s',
                        }}
                    >
                        {handleRenderNotification(notification, index)}
                    </div>
                );
            })}
        </>
    );
}

const mapStatetoProps = (state) => {
	return {
        organization    :   state.Organization,
        user            :   state.Login?.user,
        token           :   state.Login?.token,
		notifications   :   state.AppNotification,
        modules         :   state.Modules
	};
};

export default connect(
    mapStatetoProps, null
)(withNamespaces()(
    Handler
));